module.exports = __webpack_public_path__ + "media/images/icons/twotone/experiment-ab0efbd7877ab87f4bd44aaba03aa92a.svg";